declare global {
  interface Window {
    fbq?: MetaPixelFunction
    _fbq?: MetaPixelFunction
  }
}

type MetaPixelFunction = {
  (...args: unknown[]): void
  callMethod?: (...args: unknown[]) => void
  queue?: unknown[][]
  push?: (...args: unknown[]) => void
  loaded?: boolean
  version?: string
}

const PIXEL_ID = '1747159172958096'

export function initializeMetaPixel() {
  if (typeof window === 'undefined' || window.fbq) {
    return
  }

  const fbq = function (...args: unknown[]) {
    if (fbq.callMethod) {
      fbq.callMethod(...args)
      return
    }

    fbq.queue?.push(args)
  } as MetaPixelFunction

  fbq.queue = []
  fbq.push = (...args: unknown[]) => {
    fbq.queue?.push(args)
  }
  fbq.loaded = true
  fbq.version = '2.0'

  window.fbq = fbq
  window._fbq = fbq

  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  document.head.appendChild(script)

  fbq('init', PIXEL_ID)
  fbq('track', 'PageView')
}

export function trackInitiateCheckout(value: number, contentName: string) {
  window.fbq?.('track', 'InitiateCheckout', {
    content_name: contentName,
    currency: 'ARS',
    value,
  })
}
